import rootDoctorSaga from './doctorSagas';
import doctorReducer from './doctorReducer';
import store from 'index';

const key = 'doctor';
export const useDoctorSlice = () => {
    store.injectReducer(key, doctorReducer);
    store.injectSaga(key, rootDoctorSaga);
};
